import { sha256_asm } from './sha256.asm';
import { Hash } from '../hash';
import { _heap_init } from '../../other/utils';
export const _sha256_block_size = 64;
export const _sha256_hash_size = 32;
const heap_pool = [];
const asm_pool = [];
export class Sha256 extends Hash {
    constructor() {
        super();
        this.NAME = 'sha256';
        this.BLOCK_SIZE = _sha256_block_size;
        this.HASH_SIZE = _sha256_hash_size;
        this.acquire_asm();
    }
    acquire_asm() {
        if (this.heap === undefined || this.asm === undefined) {
            this.heap = heap_pool.pop() || _heap_init();
            this.asm = asm_pool.pop() || sha256_asm({ Uint8Array: Uint8Array }, null, this.heap.buffer);
            this.reset();
        }
        return { heap: this.heap, asm: this.asm };
    }
    release_asm() {
        if (this.heap !== undefined && this.asm !== undefined) {
            heap_pool.push(this.heap);
            asm_pool.push(this.asm);
        }
        this.heap = undefined;
        this.asm = undefined;
    }
    static bytes(data) {
        return new Sha256().process(data).finish().result;
    }
}
Sha256.NAME = 'sha256';
